import React, { useContext, useState } from 'react';
import Ptext from 'components/common/Ptext';
import loginHero from 'assets/images/login/loginHero.png';
import { useNavigate } from 'react-router-dom';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import 'assets/styles/common.scss';
import CheckValidation from 'utils/Validation';
import ToastNotification from 'components/common/Toast';
import { LocaleContext } from 'routes/Router';
import { getStarted, verifyOTP, forgotPassword } from 'routes/AppUrls';
import { FormattedMessage, useIntl } from 'react-intl';
import LoginLogo from 'assets/images/login/LogoAlt.svg';
import ReusableButton from 'components/common/Button';
import { useDispatch, useSelector } from 'react-redux';
import { sendOtpCallAPI } from 'store/SendOtp/action';
import AuthLayout from 'components/common/AuthLayout';
import 'assets/styles/auth.scss';

const Login = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const [conf, setConf] = ToastNotification();
  const [isPassVisible, setIsPassVisible] = useState(false);
  const [isError, setIsError] = useState(false);

  const loginLoader = useSelector((state) => state?.sendOtpReducer?.loading);

  const [formValue, setformValue] = useState({
    email: '',
    password: '',
  });

  const handleForgot = () => {
    navigate(forgotPassword(locale));
  };

  const handleSubmit = () => {
    const error = CheckValidation(formValue, intl);
    setIsError(error);
    if (error.submit) {
      let body = {
        email: formValue?.email?.toLowerCase(),
        password: formValue?.password,
      };
      dispatch(
        sendOtpCallAPI(body, {
          run: true,
          handleFunction: (res) => handleRedirect(res),
          handleToastError: (res) => ToastErrorFunction(res),
          navigate: navigate,
          toast: true,
        })
      );
    }
  };

  const ToastErrorFunction = (res) => {
    setConf({
      msg: intl.formatMessage({ id: 'Invalid Credential!' }),
      variant: 'error',
    });
  };

  const handleRedirect = (res) => {
    if (res?.data?.status_code === 200) {
      setConf({
        msg: intl.formatMessage({ id: 'login successfully!' }),
        variant: 'success',
      });
      navigate(verifyOTP(locale));
    } else {
      setConf({
        msg: intl.formatMessage({
          id: 'Invalid credentials.Please try again.',
        }),
        variant: 'error',
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setformValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <AuthLayout
      heroImage={loginHero}
      logo={LoginLogo}
      quote="Allue transformed our salon by doubling our monthly bookings and completely eliminating no-shows"
      author="Alisa Lisa"
    >
      <div className="login-content">
        <Ptext variant="title" className="welcome-title">
          <FormattedMessage id="Welcome Back!" />
        </Ptext>

        <Ptext variant="body" className="welcome-subtitle mt-2">
          <FormattedMessage id="Don't have an account?" />{' '}
          <span
            className="signup-link font-medium"
            onClick={() => navigate(getStarted(locale))}
          >
            <FormattedMessage id="Sign Up" />
          </span>
        </Ptext>

        {/* EMAIL */}
        <div className="mt-4">
          <LabelWithInput
            label={<FormattedMessage id="Email" />}
            placeholder="example@email.allue"
            name="email"
            type="text"
            value={formValue?.email}
            onChange={handleInputChange}
            errorText={
              isError && isError.email.error && isError.email.errorMessage
            }
          />
        </div>

        {/* PASSWORD */}
        <div className="mt-3">
          <LabelWithInput
            label={<FormattedMessage id="Password" />}
            placeholder="••••••••"
            name="password"
            value={formValue?.password}
            type={isPassVisible ? 'text' : 'password'}
            onChange={handleInputChange}
            InputProps={{
              endAdornment: (
                <>
                  {!isPassVisible ? (
                    <VisibilityOutlinedIcon
                      sx={{
                        cursor: 'pointer',
                        color: '#ABABAB',
                      }}
                      onClick={() => setIsPassVisible(!isPassVisible)}
                    />
                  ) : (
                    <VisibilityOffOutlinedIcon
                      sx={{
                        cursor: 'pointer',
                        color: '#ABABAB',
                      }}
                      onClick={() => setIsPassVisible(!isPassVisible)}
                    />
                  )}
                </>
              ),
            }}
            errorText={
              isError && isError.password.error && isError.password.errorMessage
            }
          />
        </div>

        {/* FORGOT PASSWORD */}
        <div className="forgot-wrapper">
          <Ptext
            variant="body"
            className="forgot-password font-medium"
            onClick={handleForgot}
          >
            <FormattedMessage id="Forgot password?" />
          </Ptext>
        </div>

        {/* BUTTON */}
        <div className="mt-4">
          <ReusableButton
            fullWidth={true}
            variant="contained"
            color="#FFFFFF"
            fontSize="16px"
            fontWeight="500"
            padding="14px"
            bgColor="#000000"
            borderRadius="999px"
            fontFamily="Poppins, sans-serif"
            loading={loginLoader}
            onClick={() => handleSubmit()}
          >
            <FormattedMessage id="Sign In" />
          </ReusableButton>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
